var chunkToChildrenMap = {
	"7": [
		474,
		820,
		270,
		90,
		16,
		834,
		324,
		495,
		749,
		838
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));